import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import { colors } from '../constants';

/** A titled card container used on detail pages. */
export function DetailCard({ title, action, children, sx }) {
  return (
    <Paper
      elevation={0}
      sx={{ p: 2.5, borderRadius: 3, border: `1px solid ${colors.border}`, ...sx }}
    >
      {(title || action) && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 1.5 }}
        >
          {title && (
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: colors.navy }}>
              {title}
            </Typography>
          )}
          {action}
        </Stack>
      )}
      {children}
    </Paper>
  );
}

/** A label/value row inside a DetailCard. */
export function InfoRow({ label, value }) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ py: 1, borderBottom: `1px solid ${colors.gray100}`, gap: 2 }}
    >
      <Typography variant="body2" sx={{ color: colors.gray500 }}>
        {label}
      </Typography>
      <Box sx={{ textAlign: 'right', color: colors.gray700, fontWeight: 500 }}>
        {value === undefined || value === null || value === '' ? '-' : value}
      </Box>
    </Stack>
  );
}

export default DetailCard;
